import { render, staticRenderFns } from "./EmbeddedSuccessPage.vue?vue&type=template&id=77f63217&scoped=true&"
import script from "./EmbeddedSuccessPage.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedSuccessPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedSuccessPage.vue?vue&type=style&index=0&id=77f63217&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f63217",
  null
  
)

export default component.exports